module.exports = file => () => import('@/views/' + file + '.vue')



// WEBPACK FOOTER //
// ./src/_app/wwka/src/router/_import_production.js